(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rl-behavior"] && !Shopify.designMode) return;
  try {
    function initRlStore(scope = document) {
  scope.querySelectorAll('[data-rl-product-root]').forEach(root => {
    if (root.dataset.rlReady) return;
    root.dataset.rlReady = 'true';
    let variants; try { variants = JSON.parse(root.querySelector('[data-rl-variant-data]').textContent); } catch { return; }
    const native = root.querySelector('[data-rl-variant]');
    const options = root.querySelector('[data-rl-options]');
    const add = root.querySelector('[data-rl-add]');
    const price = root.querySelector('[data-rl-price]');
    const compare = root.querySelector('[data-rl-compare]');
    const stock = root.querySelector('[data-rl-stock]');
    const sku = root.querySelector('[data-rl-sku]');
    const quantity = root.querySelector('input[name="quantity"]');
    const selectionNote = root.querySelector('[data-rl-selection-note]');
    const showMedia = id => {
      const panel = Array.from(root.querySelectorAll('[data-media-id]')).find(el => el.dataset.mediaId === String(id));
      if (!panel) return;
      root.querySelectorAll('[data-media-id]').forEach(el => { el.hidden = el !== panel; if (el.hidden) el.querySelectorAll('video').forEach(v => v.pause()); });
      root.querySelectorAll('[data-rl-thumb]').forEach(el => el.setAttribute('aria-current', String(el.dataset.rlThumb === String(id))));
      const zoom = root.querySelector('[data-rl-zoom]');
      if (zoom) zoom.hidden = !panel.querySelector('img');
    };
    const applyVariant = variant => {
      add.disabled = !variant?.available;
      add.textContent = !variant ? root.dataset.unavailableLabel : variant.available ? root.dataset.addLabel : root.dataset.soldLabel;
      stock.textContent = !variant ? root.dataset.unavailableLabel : variant.available ? root.dataset.availableLabel : root.dataset.soldLabel;
      if (!variant) { native.value = ''; sku.hidden = true; compare.hidden = true; return; }
      native.value = String(variant.id);
      price.textContent = variant.price;
      compare.textContent = variant.compare || '';
      compare.hidden = !variant.compare;
      sku.textContent = root.dataset.skuLabel + ' ' + (variant.sku || '');
      sku.hidden = !variant.sku;
      quantity.min = variant.min;
      quantity.step = variant.step;
      if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
      const nextQuantity = Math.max(variant.min, Math.ceil((Number(quantity.value) || variant.min) / variant.step) * variant.step);
      quantity.value = variant.max ? Math.min(nextQuantity, variant.max) : nextQuantity;
      if (variant.media) showMedia(variant.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    const syncOptions = variant => {
      if (!options || !variant) return;
      options.querySelectorAll('[data-option-position]').forEach((fieldset, index) => {
        const value = variant.options[index];
        fieldset.querySelectorAll('[data-rl-option]').forEach(el => { if (el.tagName === 'SELECT') el.value = value; else el.checked = el.value === value; });
        fieldset.querySelector('[data-rl-option-label]').textContent = value;
      });
    };
    const refreshOptions = () => {
      if (!options) return;
      const groups = Array.from(options.querySelectorAll('[data-option-position]'));
      const selected = groups.map(group => group.querySelector('select[data-rl-option], input[data-rl-option]:checked')?.value);
      groups.forEach((group, index) => {
        const controls = group.querySelectorAll('input[data-rl-option], select[data-rl-option] option');
        controls.forEach(control => {
          control.disabled = !variants.some(v => v.options[index] === control.value && v.options.slice(0, index).every((value, i) => value === selected[i]));
        });
      });
    };
    if (options && variants.length < 250) {
      syncOptions(variants.find(v => String(v.id) === native.value));
      refreshOptions();
      options.hidden = false;
      root.querySelector('[data-rl-native]').hidden = true;
      options.addEventListener('change', event => {
        if (!event.target.matches('[data-rl-option]')) return;
        const selected = Array.from(options.querySelectorAll('[data-option-position]')).map(fieldset => {
          const selectedInput = fieldset.querySelector('select[data-rl-option], input[data-rl-option]:checked');
          const value = selectedInput?.value;
          fieldset.querySelector('[data-rl-option-label]').textContent = value || '';
          return value;
        });
        let variant = variants.find(v => v.options.every((value, i) => value === selected[i]));
        const position = Number(event.target.closest('[data-option-position]').dataset.optionPosition);
        if (selectionNote) selectionNote.hidden = true;
        if (!variant && position < selected.length - 1) {
          const candidates = variants.filter(v => v.options.slice(0, position + 1).every((value, i) => value === selected[i]));
          variant = candidates.find(v => v.available) || candidates[0];
          if (variant) {
            syncOptions(variant);
            if (selectionNote) {
              selectionNote.textContent = root.dataset.selectionLabel + ' ' + variant.options.join(' / ');
              selectionNote.hidden = false;
            }
          }
        }
        applyVariant(variant);
        refreshOptions();
      });
    }
    native.addEventListener('change', () => { const variant = variants.find(v => String(v.id) === native.value); syncOptions(variant); applyVariant(variant); refreshOptions(); });
    root.querySelector('form').addEventListener('submit', event => { const variant = variants.find(v => String(v.id) === native.value); if (!variant?.available) event.preventDefault(); });
    root.querySelectorAll('[data-rl-thumb]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.rlThumb)));
    const dialog = root.querySelector('[data-rl-dialog]');
    const zoom = root.querySelector('[data-rl-zoom]');
    zoom?.addEventListener('click', () => {
      const current = root.querySelector('[data-media-id]:not([hidden]) img');
      const expanded = dialog?.querySelector('img');
      if (!current || !expanded || !dialog.showModal) return;
      const imageUrl = new URL(current.currentSrc || current.src, window.location.origin);
      imageUrl.searchParams.set('width', '2200');
      expanded.removeAttribute('srcset');
      expanded.src = imageUrl.toString();
      expanded.alt = current.alt;
      dialog.showModal();
      document.documentElement.classList.add('rl-dialog-open');
    });
    root.querySelector('[data-rl-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
    dialog?.addEventListener('close', () => { document.documentElement.classList.remove('rl-dialog-open'); zoom?.focus(); });
  });
  scope.querySelectorAll('[data-rl-hero-video]').forEach(video => {
    if (video.dataset.rlVideoReady) return;
    video.dataset.rlVideoReady = 'true';
    video.muted = true;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let autoPaused = false, userPaused = false;
    video.addEventListener('pause', () => { if (!autoPaused) userPaused = true; });
    video.addEventListener('play', () => { userPaused = false; autoPaused = false; });
    const pause = () => { autoPaused = true; video.pause(); };
    const play = () => { if (!motion.matches && !navigator.connection?.saveData && !userPaused) video.play().catch(() => {}); };
    motion.addEventListener('change', event => { if (event.matches) pause(); });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) play(); else pause();
      }), { threshold: .35 });
      observer.observe(video);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(video)) observer.disconnect(); }, { once: true });
    } else play();
  });
  scope.querySelectorAll('[data-rl-quantity]').forEach(wrapper => {
    if (wrapper.dataset.rlReady) return;
    wrapper.dataset.rlReady = 'true';
    wrapper.querySelectorAll('[data-rl-step]').forEach(button => button.addEventListener('click', () => {
      const input = wrapper.querySelector('input');
      const min = Number(input.min || 0), max = input.max ? Number(input.max) : Infinity;
      const next = (Number(input.value) || min) + Number(button.dataset.rlStep) * Number(input.step || 1);
      input.value = Math.max(min, Math.min(max, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
  scope.querySelectorAll('[data-rl-menu]').forEach(menu => {
    if (menu.dataset.rlReady) return;
    menu.dataset.rlReady = 'true';
    menu.addEventListener('toggle', () => {
      const summary = menu.querySelector('summary');
      summary?.setAttribute('aria-expanded', String(menu.open));
      if (menu.open) {
        document.querySelectorAll('[data-rl-menu]').forEach(other => { if (other !== menu) other.open = false; });
        if (menu.classList.contains('rl-search-details')) menu.querySelector('input[type="search"]')?.focus();
      }
    });
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initRlStore()); else initRlStore();
document.addEventListener('shopify:section:load', event => initRlStore(event.target));
document.addEventListener('click', event => { document.querySelectorAll('[data-rl-menu][open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }); });
  } catch(e) { console.error(e); }
})();

})();
